// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__32Cgo","rounded":"Radio_rounded__3c75F"};